<template>
    <svg
        :width="props.width"
        :height="props.height"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8 12.5 11.575 12.6083 12.3 12.8083"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M18.3333 15C18.3333 15.2666 18.3 15.525 18.2333 15.775C18.1583 16.1083 18.0249 16.4333 17.8499 16.7166C17.2749 17.6833 16.2166 18.3333 15 18.3333C14.1416 18.3333 13.3666 18.0083 12.7833 17.4749C12.5333 17.2583 12.3166 17 12.15 16.7166C11.8416 16.2166 11.6666 15.625 11.6666 15C11.6666 14.1 12.025 13.275 12.6083 12.675C13.2166 12.05 14.0666 11.6666 15 11.6666C15.9833 11.6666 16.8749 12.0916 17.4749 12.775C18.0083 13.3666 18.3333 14.15 18.3333 15Z"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M16.2416 14.9833H13.7583"
        :stroke="props.color"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
    </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: 'rgb(var(--locumate-clr-text))',
    },
    width: {
        type: Number,
        default: 20,
    },
    height: {
        type: Number,
        default: 20,
    },
});
</script>
